export default __webpack_public_path__ + "static/media/thailand_onshore_wind.0270f2fc.png";